import { AttachmentS3 } from '@cbgms/api'

export const processedFiles = async (attachments: AttachmentS3[], uploadedFiles: string[]) => {
  return attachments?.map(file => {
    if (file.Key?.trim()) {
      return {
        Key: file.Key,
        Name: file.Name,
        ContentType: file.ContentType || ''
      }
    } else {
      const fileName = file.Name?.replace(/ /g, '-') || ''
      const uploadedFile = uploadedFiles.find(uploadedPath => {
        const uploadedFileName = uploadedPath?.split('/').pop()
        return uploadedFileName === fileName
      })

      if (uploadedFile && fileName) {
        const extension = fileName?.split('.').pop() || ''
        return {
          Key: uploadedFile,
          Name: fileName,
          ContentType: extension
        }
      }

      return {
        Key: '',
        Name: '',
        ContentType: ''
      }
    }
  })
}
